export default __webpack_public_path__ + "static/media/red-carpet-2.a5f5850a.png";